import { render } from "./Forget.vue?vue&type=template&id=1241f6f4"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=1241f6f4&lang=css"

import exportComponent from "E:\\claude\\match\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__